import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

const CustomersDropdown = ({ theme, dropdown, navResponsive }) => (
  <div>
    <div className="pt-10 pb-12 px-14" data-first-dropdown-section>
      <div className="flex grid-cols-2 gap-6 xl:grid-cols-4 min-w-max">
        <div>
          <p className="mb-6 text-xs leading-4 tracking-widest text-neutral-400">GENERATIVE AI</p>
          <ul className="space-y-5 w-max min-w-[240px]">
            {dropdownItems[dropdown].desktop.generativeAi.map(item => (
              <DropdownItem
                key={item.title}
                href={item.href}
                icon={item.icon}
                title={item.title}
                text={item.text}
                colors={theme.dropdown.items.solid}
                itemType={item.type}
                navResponsive={navResponsive}
                minHeight
              />
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-6 text-xs leading-4 tracking-widest text-neutral-400">U.S. GOVERNMENT</p>
          <ul className="space-y-5 w-max min-w-[240px]">
            {dropdownItems[dropdown].desktop.government.map(item => (
              <DropdownItem
                key={item.title}
                href={item.href}
                icon={item.icon}
                title={item.title}
                text={item.text}
                colors={theme.dropdown.items.solid}
                itemType={item.type}
                navResponsive={navResponsive}
                minHeight
              />
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-6 text-xs leading-4 tracking-widest text-neutral-400">ENTERPRISES</p>
          <ul className="space-y-5 w-max min-w-[240px]">
            {dropdownItems[dropdown].desktop.enterprises.map(item => (
              <DropdownItem
                key={item.title}
                href={item.href}
                icon={item.icon}
                title={item.title}
                text={item.text}
                colors={theme.dropdown.items.solid}
                itemType={item.type}
                navResponsive={navResponsive}
                minHeight
              />
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-6 text-xs leading-4 tracking-widest text-neutral-400">STARTUPS</p>
          <ul className="space-y-5 w-max min-w-[180px]">
            {dropdownItems[dropdown].desktop.startups.map(item => (
              <DropdownItem
                key={item.title}
                href={item.href}
                icon={item.icon}
                title={item.title}
                text={item.text}
                colors={theme.dropdown.items.solid}
                itemType={item.type}
                navResponsive={navResponsive}
                minHeight
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

CustomersDropdown.defaultProps = {
  dropdown: 'customers',
  navResponsive: false
};

export default CustomersDropdown;
